module.exports = __webpack_public_path__ + "img/banner5.cee47c08.png";